export const INPUT_SECTION_CLASS = 'input-section'
export const ERROR_MESSAGE_CLASS = 'error-message'
